import { render, staticRenderFns } from "./configGroupManage.vue?vue&type=template&id=1764271b&"
import script from "./configGroupManage.vue?vue&type=script&lang=js&"
export * from "./configGroupManage.vue?vue&type=script&lang=js&"
import style0 from "./configGroupManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports